let config = {
    envName: "production",
    offlineFairsApi: "https://events-api.azent.com",
    lmsApi: "https://lms-api.azent.com",
    cmsApi: "https://cms-service-v2.azent.com/v1",
    internalFairUniversitiesJsonUrl:
        "https://azent-fairs.s3.ap-south-1.amazonaws.com/fairs/final_staffing_9th_may_2026.json",
};

export default config;
